import * as React from "react";

function SvgIcGoogle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M.498 19.568zm5.29-6.852c2.07.062 3.459-2.086 3.102-4.797-.358-2.711-2.326-4.886-4.397-4.948-2.07-.061-3.46 2.013-3.102 4.725.357 2.71 2.325 4.959 4.397 5.02zM23.52 5.76V3.841A3.852 3.852 0 0019.68 0H4.32A3.852 3.852 0 00.482 3.733c1.313-1.155 3.134-2.122 5.015-2.122h8.038l-1.799 1.521H9.187c1.69.648 2.591 2.614 2.591 4.63 0 1.693-.94 3.148-2.27 4.184-1.297 1.01-1.543 1.434-1.543 2.293 0 .733 1.39 1.98 2.116 2.493 2.123 1.496 2.81 2.887 2.81 5.208 0 .37-.045.738-.135 1.101h6.924a3.85 3.85 0 003.84-3.841V7.201H19.2v4.32h-1.44v-4.32h-4.32v-1.44h4.32v-4.32h1.44v4.32h4.32V5.76zM4.663 17.234c.486 0 .932-.014 1.394-.014-.61-.592-1.095-1.318-1.095-2.213 0-.531.17-1.043.408-1.497-.243.017-.49.022-.745.022-1.673 0-3.094-.541-4.144-1.437v6.052c1.202-.571 2.63-.914 4.183-.914h-.001zm-4.106 2.73zm10.171 1.475c-.339-1.323-1.54-1.98-3.215-3.14a6.728 6.728 0 00-2-.32c-2.016-.022-3.894.786-4.954 1.988a3.855 3.855 0 003.763 3.073h6.445c.042-.25.06-.509.06-.775a3.54 3.54 0 00-.098-.826h-.001z"
        />
      </g>
    </svg>
  );
}

export default SvgIcGoogle;
